import { render, staticRenderFns } from "./SmsFavoriteContact.vue?vue&type=template&id=79bee788&scoped=true&"
import script from "./SmsFavoriteContact.vue?vue&type=script&lang=js&"
export * from "./SmsFavoriteContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bee788",
  null
  
)

/* custom blocks */
import block0 from "./resources/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusr%2Flocal%2Fbamboo-home%2Flocal-working-dir%2F56885249%2FEIPSMS-UB-DB%2Fsrc%2Fcomponents%2FSmsFavoriteContact%2FSmsFavoriteContact.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports